import React from 'react';

import type { FC } from 'react';

export const ChevronLeft: FC<React.SVGAttributes<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}>
      <path d="M12.5001 5.5875C12.1751 5.2625 11.6501 5.2625 11.3251 5.5875L7.5001 9.4125C7.1751 9.7375 7.1751 10.2625 7.5001 10.5875L11.3251 14.4125C11.6501 14.7375 12.1751 14.7375 12.5001 14.4125C12.8251 14.0875 12.8251 13.5625 12.5001 13.2375L9.26676 9.99583L12.5001 6.7625C12.8251 6.4375 12.8168 5.90417 12.5001 5.5875Z" />
    </svg>
  );
};
